import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/api/audit-logs").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="audit-log-page">
      <div>
        <h1 className="text-3xl font-heading font-semibold tracking-tight">Audit Log</h1>
        <p className="text-sm text-slate-500 mt-1">Immutable record of important actions.</p>
      </div>
      <Card className="border-slate-200 shadow-none p-4">
        <table className="data-table w-full">
          <thead><tr><th>Time</th><th>User</th><th>Action</th><th>Entity</th><th>ID</th><th>Changes</th></tr></thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id}>
                <td className="text-xs">{a.created_at?.replace("T", " ").slice(0, 19)}</td>
                <td>{a.user_email}</td>
                <td className="font-medium">{a.action}</td>
                <td>{a.entity_type}</td>
                <td className="font-mono text-xs">{a.entity_id?.slice(0, 8)}…</td>
                <td className="text-xs text-slate-500">{JSON.stringify(a.changes || {}).slice(0, 80)}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="text-center text-slate-500 py-8">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
